import React from 'react';

import usePageConfig from '@client/hooks/usePageConfig';
import { type GroupItem, type ListComponentProps, ItemList, SelectGroupTree } from '@ledium/ui-common';

type EnrichedGroupItem = ListComponentProps<GroupItem>['itemList'][number];

interface GroupListProps {
    itemList: EnrichedGroupItem[];
    onChange: (item: EnrichedGroupItem | null) => void;
    onEdit: (item: EnrichedGroupItem) => void;
}

const GroupsMainMenu = () => {
    usePageConfig('groups');

    function ListComponent({ itemList, onChange, onEdit }: GroupListProps) {
        function onSelect(groupItem: GroupItem | undefined) {
            onChange(groupItem ?? null);
        }

        return <SelectGroupTree itemList={itemList} defaultSelected="root" onSelect={onSelect} onEdit={onEdit} />;
    }

    return <ItemList showEditButton ListComponent={ListComponent} />;
};

export default GroupsMainMenu;
